import { useState } from "react"
import { fetchApi } from "../helpers"

export const useCarreras = (url, headers, value) => {
    const [carreras, setCarreras] = useState([])
    const handleCarreras = async (IdPlan, setFieldValue, Idsede) => {
        setFieldValue(value, IdPlan)

        try {
            if (IdPlan !== '') {
                const res = await fetchApi({
                    url: url + '/utils/busquedas',
                    headers,
                    content: {
                        opcion: "CARRERAS",
                        Idsede: Idsede,
                        idplan: IdPlan,
                        filtro: '2'
                    }
                })
                setCarreras(res)
            }
            else {
                setCarreras([])
            }
            // console.log(res)

        } catch (err) {
            console.log(err)
        }
    }

    return [carreras, handleCarreras]
}